import { Box, makeStyles, Paper, Typography } from "@material-ui/core";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { useTranslation } from "react-i18next";

export default function EmptyState() {
  const { t } = useTranslation("mxheroShares");
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      padding="72px 30px"
      component={Paper}
      boxShadow={0}
    >
      <div className={classes.iconContainer}>
        <VerifiedUserIcon className={classes.icon} />
      </div>
      <Typography variant="h6" className={classes.title}>
        {t("malware.emptyListTitle")}
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.description}
      >
        {t("malware.emptyListDesc")}
      </Typography>
    </Box>
  );
}

const useStyles = makeStyles(theme => ({
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 88,
    height: 88,
    marginBottom: 24,
    borderRadius: "50%",
    backgroundColor: "#e3f4fb",
    boxShadow: "0 0 0 12px rgba(0, 158, 210, 0.06)",
    color: theme.palette.primary.main,
  },
  icon: { fontSize: 44 },
  title: { marginBottom: 8, fontWeight: 500 },
  description: { maxWidth: 460, lineHeight: 1.6 },
}));
